
import 'vue-material-design-icons/styles.css'
import Ribbon from 'vue-ribbon'
import LeftIcon from 'vue-material-design-icons/ChevronLeftCircle'
import RightIcon from 'vue-material-design-icons/ChevronRightCircle'
import PlusIcon from 'vue-material-design-icons/PlusCircle'
import MinusIcon from 'vue-material-design-icons/MinusCircle'
import Flipbook from './Flipbook'

export default
  name: 'app'
  components: { Flipbook, LeftIcon, RightIcon, PlusIcon, MinusIcon, Ribbon }
  data: ->
    pages: [],
    pagesHiRes: [],
    hasMouse: true
    pageNum: null
  methods:
    onFlipLeftStart: (page) -> console.log 'flip-left-start', page
    onFlipLeftEnd: (page) ->
      console.log 'flip-left-end', page
      window.location.hash = '#' + page
    onFlipRightStart: (page) -> console.log 'flip-right-start', page
    onFlipRightEnd: (page) ->
      console.log 'flip-right-end', page
      window.location.hash = '#' + page
    onZoomStart: (zoom) -> console.log 'zoom-start', zoom
    onZoomEnd: (zoom) -> console.log 'zoom-end', zoom
    setPageFromHash: ->
      n = parseInt window.location.hash.slice(1), 10
      @pageNum = n if isFinite n
  mounted: ->
    window.addEventListener 'keydown', (ev) =>
      flipbook = @$refs.flipbook
      return unless flipbook
      flipbook.flipLeft() if ev.keyCode == 37 and flipbook.canFlipLeft
      flipbook.flipRight() if ev.keyCode == 39 and flipbook.canFlipRight

    # Simulate asynchronous pages initialization
    setTimeout (=>
      @pages = [
        null
        'images/b1.jpg'
        'images/b2.jpg'
        'images/b3.jpg'
        'images/b4.jpg'
        'images/b5.jpg'
        'images/b6.jpg'
        'images/b7.jpg'
        'images/b8.jpg'
        'images/b9.jpg'
        'images/b10.jpg'
        'images/b11.jpg'
        'images/b12.jpg'
        'images/b13.jpg'
        'images/b14.jpg'
        'images/b15.jpg'
        'images/b16.jpg'
        'images/b17.jpg'
        'images/b18.jpg'
        'images/b19.jpg'
        'images/b20.jpg'
        'images/b21.jpg'
        'images/b22.jpg'
        'images/b23.jpg'
        'images/b24.jpg'
        'images/b25.jpg'
        'images/b26.jpg'
        'images/b27.jpg'
        'images/b28.jpg'
        'images/b29.jpg'
        'images/b30.jpg'
        'images/b31.jpg'
        'images/b32.jpg'
        'images/b33.jpg'
        'images/b34.jpg'
        'images/b35.jpg'
        'images/b36.jpg'
        'images/b37.jpg'
        'images/b38.jpg'
        'images/b39.jpg'
        'images/b40.jpg'
        'images/b41.jpg'
        'images/b42.jpg'
        'images/b43.jpg'
        'images/b44.jpg'
        'images/b45.jpg'
        'images/b46.jpg'
        'images/b47.jpg'
        'images/b48.jpg'
        'images/b49.jpg'
        'images/b50.jpg'
        'images/b51.jpg'
        'images/b52.jpg'
        'images/b53.jpg'
        'images/b54.jpg'
        'images/b55.jpg'
        'images/b56.jpg'
        'images/b57.jpg'
        'images/b58.jpg'
        'images/b59.jpg'
        'images/b60.jpg'
        'images/b61.jpg'
        'images/b62.jpg'
        'images/b63.jpg'
        'images/b64.jpg'
        'images/b65.jpg'
        'images/b66.jpg'
        'images/b67.jpg'
        'images/b68.jpg'
        'images/b69.jpg'
        'images/b70.jpg'
        'images/b71.jpg'
        'images/b72.jpg'
        'images/b73.jpg'
        'images/b74.jpg'
        'images/b75.jpg'
        'images/b76.jpg'
        'images/b77.jpg'
        'images/b78.jpg'
        'images/b79.jpg'
        'images/b80.jpg'
        'images/b81.jpg'
        'images/b82.jpg'
        'images/b83.jpg'
        'images/b84.jpg'
        'images/b85.jpg'
        'images/b86.jpg'
        'images/b87.jpg'
        'images/b88.jpg'
        'images/b89.jpg'
        'images/b90.jpg'
        'images/b91.jpg'
        'images/b92.jpg'
        'images/b93.jpg'
        'images/b94.jpg'
        'images/b95.jpg'
        'images/b96.jpg'
        'images/b97.jpg'
        'images/b98.jpg'
        'images/b99.jpg'
        'images/b100.jpg'
        'images/b101.jpg'
        'images/b102.jpg'
        'images/b103.jpg'
        'images/b104.jpg'
        'images/b105.jpg'
        'images/b106.jpg'
        'images/b107.jpg'
        'images/b108.jpg'
        'images/b109.jpg'
        'images/b110.jpg'
        'images/b111.jpg'
        'images/b112.jpg'
        'images/b113.jpg'
        'images/b114.jpg'
        'images/b115.jpg'
        'images/b116.jpg'
        'images/b117.jpg'
        'images/b118.jpg'
        'images/b119.jpg'
        'images/b120.jpg'
        'images/b121.jpg'
        'images/b122.jpg'
        'images/b123.jpg'
        'images/b124.jpg'
        'images/b125.jpg'
        'images/b126.jpg'
        'images/b127.jpg'
        'images/b128.jpg'
        'images/b129.jpg'
        'images/b130.jpg'
        'images/b131.jpg'
        'images/b132.jpg'
        'images/b133.jpg'
        'images/b134.jpg'
        'images/b135.jpg'
        'images/b136.jpg'
        'images/b137.jpg'
        'images/b138.jpg'
        'images/b139.jpg'
        'images/b140.jpg'
        'images/b141.jpg'
        'images/b142.jpg'
        'images/b143.jpg'
        'images/b144.jpg'
        'images/b145.jpg'
        'images/b146.jpg'
        'images/b147.jpg'
        'images/b148.jpg'
        'images/b149.jpg'
        'images/b150.jpg'
        'images/b151.jpg'
        'images/b152.jpg'
        'images/b153.jpg'
        'images/b154.jpg'
        'images/b155.jpg'
        'images/b156.jpg'
        'images/b157.jpg'
        'images/b158.jpg'
        'images/b159.jpg'
        'images/b160.jpg'
        'images/b161.jpg'
        'images/b162.jpg'
        'images/b163.jpg'
        'images/b164.jpg'
        'images/b165.jpg'
        'images/b166.jpg'
        'images/b167.jpg'
        'images/b168.jpg'
        'images/b169.jpg'
        'images/b170.jpg'
        'images/b171.jpg'
        'images/b172.jpg'
        'images/b173.jpg'
        'images/b174.jpg'
        'images/b175.jpg'
        'images/b176.jpg'
        'images/b177.jpg'
        'images/b178.jpg'
        'images/b179.jpg'
        'images/b180.jpg'
        'images/b181.jpg'
        'images/b182.jpg'
        'images/b183.jpg'
        'images/b184.jpg'
        'images/b185.jpg'
        'images/b186.jpg'
        'images/b187.jpg'
        'images/b188.jpg'
        'images/b189.jpg'
        'images/b190.jpg'
        'images/b191.jpg'
        'images/b192.jpg'
        'images/b193.jpg'
        'images/b194.jpg'
        'images/b195.jpg'
        'images/b196.jpg'
        'images/b197.jpg'
        'images/b198.jpg'
        'images/b199.jpg'
        'images/b200.jpg'
        'images/b201.jpg'
        'images/b202.jpg'
        'images/b203.jpg'
        'images/b204.jpg'
        'images/b205.jpg'
        'images/b206.jpg'
        'images/b207.jpg'
        'images/b208.jpg'
        'images/b209.jpg'
        'images/b210.jpg'
        'images/b211.jpg'
        'images/b212.jpg'
        'images/b213.jpg'
        'images/b214.jpg'
        'images/b215.jpg'
        'images/b216.jpg'
        'images/b217.jpg'
        'images/b218.jpg'
        'images/b219.jpg'
        'images/b220.jpg'
        'images/b221.jpg'
        'images/b222.jpg'
        'images/b223.jpg'
        'images/b224.jpg'
        'images/b225.jpg'
        'images/b226.jpg'
        'images/b227.jpg'
        'images/b228.jpg'
        'images/b229.jpg'
        'images/b230.jpg'
        'images/b231.jpg'
        'images/b232.jpg'
        'images/b233.jpg'
        'images/b234.jpg'
        'images/b235.jpg'
        'images/b236.jpg'
        'images/b237.jpg'
        'images/b238.jpg'
        'images/b239.jpg'
        'images/b240.jpg'
        'images/b241.jpg'
        'images/b242.jpg'
        'images/b243.jpg'
        'images/b244.jpg'
        'images/b245.jpg'
        'images/b246.jpg'
        'images/b247.jpg'
        'images/b248.jpg'
        'images/b249.jpg'
        'images/b250.jpg'
        'images/b251.jpg'
        'images/b252.jpg'
        'images/b253.jpg'
        'images/b254.jpg'
        'images/b255.jpg'
        'images/b256.jpg'
        'images/b257.jpg'
        'images/b258.jpg'
        'images/b259.jpg'
        'images/b260.jpg'
        'images/b261.jpg'
        'images/b262.jpg'
        'images/b263.jpg'
        'images/b264.jpg'
        'images/b265.jpg'
        'images/b266.jpg'
        'images/b267.jpg'
        'images/b268.jpg'
        'images/b269.jpg'
        'images/b270.jpg'
        'images/b271.jpg'
        'images/b272.jpg'
        'images/b273.jpg'
        'images/b274.jpg'
        'images/b275.jpg'
        'images/b276.jpg'
        'images/b277.jpg'
        'images/b278.jpg'
        'images/b279.jpg'
        'images/b280.jpg'
        'images/b281.jpg'
        'images/b282.jpg'
        'images/b283.jpg'
        'images/b284.jpg'
        'images/b285.jpg'
        'images/b286.jpg'
        'images/b287.jpg'
        'images/b288.jpg'
        'images/b289.jpg'
        'images/b290.jpg'
        'images/b291.jpg'
        'images/b292.jpg'
        'images/b293.jpg'
        'images/b294.jpg'
        'images/b295.jpg'
        'images/b296.jpg'
        'images/b297.jpg'
        'images/b298.jpg'
        'images/b299.jpg'
        'images/b300.jpg'
        'images/b301.jpg'
        'images/b302.jpg'
        'images/b303.jpg'
        'images/b304.jpg'
        'images/b305.jpg'
        'images/b306.jpg'
        'images/b307.jpg'
        'images/b308.jpg'
        'images/b309.jpg'
        'images/b310.jpg'
        'images/b311.jpg'
        'images/b312.jpg'
        'images/b313.jpg'
        'images/b314.jpg'
        'images/b315.jpg'
        'images/b316.jpg'
        'images/b317.jpg'
        'images/b318.jpg'
        'images/b319.jpg'
        'images/b320.jpg'
        'images/b321.jpg'
        'images/b322.jpg'
        'images/b323.jpg'
        'images/b324.jpg'
      ]
      @pagesHiRes = [
        null
        'images/b1.jpg'
        'images/b2.jpg'
        'images/b3.jpg'
        'images/b4.jpg'
        'images/b5.jpg'
        'images/b6.jpg'
        'images/b7.jpg'
        'images/b8.jpg'
        'images/b9.jpg'
        'images/b10.jpg'
        'images/b11.jpg'
        'images/b12.jpg'
        'images/b13.jpg'
        'images/b14.jpg'
        'images/b15.jpg'
        'images/b16.jpg'
        'images/b17.jpg'
        'images/b18.jpg'
        'images/b19.jpg'
        'images/b20.jpg'
        'images/b21.jpg'
        'images/b22.jpg'
        'images/b23.jpg'
        'images/b24.jpg'
        'images/b25.jpg'
        'images/b26.jpg'
        'images/b27.jpg'
        'images/b28.jpg'
        'images/b29.jpg'
        'images/b30.jpg'
        'images/b31.jpg'
        'images/b32.jpg'
        'images/b33.jpg'
        'images/b34.jpg'
        'images/b35.jpg'
        'images/b36.jpg'
        'images/b37.jpg'
        'images/b38.jpg'
        'images/b39.jpg'
        'images/b40.jpg'
        'images/b41.jpg'
        'images/b42.jpg'
        'images/b43.jpg'
        'images/b44.jpg'
        'images/b45.jpg'
        'images/b46.jpg'
        'images/b47.jpg'
        'images/b48.jpg'
        'images/b49.jpg'
        'images/b50.jpg'
        'images/b51.jpg'
        'images/b52.jpg'
        'images/b53.jpg'
        'images/b54.jpg'
        'images/b55.jpg'
        'images/b56.jpg'
        'images/b57.jpg'
        'images/b58.jpg'
        'images/b59.jpg'
        'images/b60.jpg'
        'images/b61.jpg'
        'images/b62.jpg'
        'images/b63.jpg'
        'images/b64.jpg'
        'images/b65.jpg'
        'images/b66.jpg'
        'images/b67.jpg'
        'images/b68.jpg'
        'images/b69.jpg'
        'images/b70.jpg'
        'images/b71.jpg'
        'images/b72.jpg'
        'images/b73.jpg'
        'images/b74.jpg'
        'images/b75.jpg'
        'images/b76.jpg'
        'images/b77.jpg'
        'images/b78.jpg'
        'images/b79.jpg'
        'images/b80.jpg'
        'images/b81.jpg'
        'images/b82.jpg'
        'images/b83.jpg'
        'images/b84.jpg'
        'images/b85.jpg'
        'images/b86.jpg'
        'images/b87.jpg'
        'images/b88.jpg'
        'images/b89.jpg'
        'images/b90.jpg'
        'images/b91.jpg'
        'images/b92.jpg'
        'images/b93.jpg'
        'images/b94.jpg'
        'images/b95.jpg'
        'images/b96.jpg'
        'images/b97.jpg'
        'images/b98.jpg'
        'images/b99.jpg'
        'images/b100.jpg'
        'images/b101.jpg'
        'images/b102.jpg'
        'images/b103.jpg'
        'images/b104.jpg'
        'images/b105.jpg'
        'images/b106.jpg'
        'images/b107.jpg'
        'images/b108.jpg'
        'images/b109.jpg'
        'images/b110.jpg'
        'images/b111.jpg'
        'images/b112.jpg'
        'images/b113.jpg'
        'images/b114.jpg'
        'images/b115.jpg'
        'images/b116.jpg'
        'images/b117.jpg'
        'images/b118.jpg'
        'images/b119.jpg'
        'images/b120.jpg'
        'images/b121.jpg'
        'images/b122.jpg'
        'images/b123.jpg'
        'images/b124.jpg'
        'images/b125.jpg'
        'images/b126.jpg'
        'images/b127.jpg'
        'images/b128.jpg'
        'images/b129.jpg'
        'images/b130.jpg'
        'images/b131.jpg'
        'images/b132.jpg'
        'images/b133.jpg'
        'images/b134.jpg'
        'images/b135.jpg'
        'images/b136.jpg'
        'images/b137.jpg'
        'images/b138.jpg'
        'images/b139.jpg'
        'images/b140.jpg'
        'images/b141.jpg'
        'images/b142.jpg'
        'images/b143.jpg'
        'images/b144.jpg'
        'images/b145.jpg'
        'images/b146.jpg'
        'images/b147.jpg'
        'images/b148.jpg'
        'images/b149.jpg'
        'images/b150.jpg'
        'images/b151.jpg'
        'images/b152.jpg'
        'images/b153.jpg'
        'images/b154.jpg'
        'images/b155.jpg'
        'images/b156.jpg'
        'images/b157.jpg'
        'images/b158.jpg'
        'images/b159.jpg'
        'images/b160.jpg'
        'images/b161.jpg'
        'images/b162.jpg'
        'images/b163.jpg'
        'images/b164.jpg'
        'images/b165.jpg'
        'images/b166.jpg'
        'images/b167.jpg'
        'images/b168.jpg'
        'images/b169.jpg'
        'images/b170.jpg'
        'images/b171.jpg'
        'images/b172.jpg'
        'images/b173.jpg'
        'images/b174.jpg'
        'images/b175.jpg'
        'images/b176.jpg'
        'images/b177.jpg'
        'images/b178.jpg'
        'images/b179.jpg'
        'images/b180.jpg'
        'images/b181.jpg'
        'images/b182.jpg'
        'images/b183.jpg'
        'images/b184.jpg'
        'images/b185.jpg'
        'images/b186.jpg'
        'images/b187.jpg'
        'images/b188.jpg'
        'images/b189.jpg'
        'images/b190.jpg'
        'images/b191.jpg'
        'images/b192.jpg'
        'images/b193.jpg'
        'images/b194.jpg'
        'images/b195.jpg'
        'images/b196.jpg'
        'images/b197.jpg'
        'images/b198.jpg'
        'images/b199.jpg'
        'images/b200.jpg'
        'images/b201.jpg'
        'images/b202.jpg'
        'images/b203.jpg'
        'images/b204.jpg'
        'images/b205.jpg'
        'images/b206.jpg'
        'images/b207.jpg'
        'images/b208.jpg'
        'images/b209.jpg'
        'images/b210.jpg'
        'images/b211.jpg'
        'images/b212.jpg'
        'images/b213.jpg'
        'images/b214.jpg'
        'images/b215.jpg'
        'images/b216.jpg'
        'images/b217.jpg'
        'images/b218.jpg'
        'images/b219.jpg'
        'images/b220.jpg'
        'images/b221.jpg'
        'images/b222.jpg'
        'images/b223.jpg'
        'images/b224.jpg'
        'images/b225.jpg'
        'images/b226.jpg'
        'images/b227.jpg'
        'images/b228.jpg'
        'images/b229.jpg'
        'images/b230.jpg'
        'images/b231.jpg'
        'images/b232.jpg'
        'images/b233.jpg'
        'images/b234.jpg'
        'images/b235.jpg'
        'images/b236.jpg'
        'images/b237.jpg'
        'images/b238.jpg'
        'images/b239.jpg'
        'images/b240.jpg'
        'images/b241.jpg'
        'images/b242.jpg'
        'images/b243.jpg'
        'images/b244.jpg'
        'images/b245.jpg'
        'images/b246.jpg'
        'images/b247.jpg'
        'images/b248.jpg'
        'images/b249.jpg'
        'images/b250.jpg'
        'images/b251.jpg'
        'images/b252.jpg'
        'images/b253.jpg'
        'images/b254.jpg'
        'images/b255.jpg'
        'images/b256.jpg'
        'images/b257.jpg'
        'images/b258.jpg'
        'images/b259.jpg'
        'images/b260.jpg'
        'images/b261.jpg'
        'images/b262.jpg'
        'images/b263.jpg'
        'images/b264.jpg'
        'images/b265.jpg'
        'images/b266.jpg'
        'images/b267.jpg'
        'images/b268.jpg'
        'images/b269.jpg'
        'images/b270.jpg'
        'images/b271.jpg'
        'images/b272.jpg'
        'images/b273.jpg'
        'images/b274.jpg'
        'images/b275.jpg'
        'images/b276.jpg'
        'images/b277.jpg'
        'images/b278.jpg'
        'images/b279.jpg'
        'images/b280.jpg'
        'images/b281.jpg'
        'images/b282.jpg'
        'images/b283.jpg'
        'images/b284.jpg'
        'images/b285.jpg'
        'images/b286.jpg'
        'images/b287.jpg'
        'images/b288.jpg'
        'images/b289.jpg'
        'images/b290.jpg'
        'images/b291.jpg'
        'images/b292.jpg'
        'images/b293.jpg'
        'images/b294.jpg'
        'images/b295.jpg'
        'images/b296.jpg'
        'images/b297.jpg'
        'images/b298.jpg'
        'images/b299.jpg'
        'images/b300.jpg'
        'images/b301.jpg'
        'images/b302.jpg'
        'images/b303.jpg'
        'images/b304.jpg'
        'images/b305.jpg'
        'images/b306.jpg'
        'images/b307.jpg'
        'images/b308.jpg'
        'images/b309.jpg'
        'images/b310.jpg'
        'images/b311.jpg'
        'images/b312.jpg'
        'images/b313.jpg'
        'images/b314.jpg'
        'images/b315.jpg'
        'images/b316.jpg'
        'images/b317.jpg'
        'images/b318.jpg'
        'images/b319.jpg'
        'images/b320.jpg'
        'images/b321.jpg'
        'images/b322.jpg'
        'images/b323.jpg'
        'images/b324.jpg'
      ]
    ), 1

    window.addEventListener 'hashchange', @setPageFromHash
    @setPageFromHash()
